import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import pipRatings from "../../../../src/data/articles/cube-prospective-fallout/pip-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  pipRatings,
  ProspectiveIntro,
  React
};